//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 *  h5商家优惠券专题页
 **/
import config from 'config';
import action from './action';
import { yoButton } from 'components';
export default {
  name: 'couponPage',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  async created () {
    /**
     * @params
     *  enterprise  商家编码
     *  title 活动标题
     *  is_platform 是否是平台商家
     **/
    const { enterprise, token, channel, title, is_platform, paramsNo } = this.params;
    config.enterprise = enterprise;
    config.token = token;
    this.channel = channel;
    this.enterprise = enterprise;
    this.paramsNo = paramsNo;
    this.pageTitle = title !== 'undefined' && title !== 'null' && title ? Array.isArray(title) ? title[0] : title : '领取优惠券';
    this.isPlatform = is_platform;
    await this.checkReceiveCoupon();
  },
  mounted() {
    console.log('--------------mounted', this, config, G, window);
  },
  data() {
    return {
      enterprise: undefined,
      isPlatform: undefined,
      paramsNo: undefined,
      channel: undefined, // 渠道（1-微信公众号 2微信社区分享）
      info: {},
      appInfo: {}, // app信息
      pageTitle: undefined,
      received: false
    };
  },
  computed: {
    couponImg() {
      switch (this.enterprise) {
        case 'E201805091153326581': {
          return '/static/img/app/coupon/hxykCoupon.jpeg';
        }
        default: {
          return this.received ? '/static/img/app/coupon/receivedCoupon.png' : '/static/img/app/coupon/receiveCoupon.png'
        }
      }
    }
  },
  filters: {},
  components: {
    yoButton
  },
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/coupon/page.vue